import useActiveTabStore from "../../../stores/useActiveTab.jsx";
import useMainContentTab from "../../../stores/useMainContentTab.jsx";

export default function StartContent() {
    const setMainContentTab = useMainContentTab((state) => state.setMainContentTab);
    const setActiveTab = useActiveTabStore((state) => state.setActiveTab);
    const MainTab = useMainContentTab((state) => state.activeTab)
    const ActiveTab = useActiveTabStore((state) => state.activeTab)

    console.log("ActiveTab: ", ActiveTab)
    console.log("MainTab: ", MainTab)

    return (
        <>
            <div className="mt-[75vh] sm:mt-[85vh]">
                <div className="grid place-items-center gap-3">
                    <button
                        onClick={() => {
                            setMainContentTab("MainContentScreen")
                            setActiveTab("Home")
                        }}
                        className="bg-transparent backdrop-blur-md font-bold w-3/4 py-3 px-6 text-white rounded-sm pointer-events-auto active:bg-black shadow-glow-md active:shadow-glow-lg"
                    >
                        Start
                    </button>
                    <div className="text-sm font-bold text-gray-600">
                        Please click the button to start the portfolio
                    </div>
                </div>
            </div>
        </>
    )
}
